import { Moment } from 'moment';
import React, { FC } from 'react';
import { Project } from 'api/project';
import { Task } from 'api/tasks';
import { EnabledSourcesConfiguration } from 'api/timesheets/configuration/configuration';
import { Drawer } from 'components/organisms/timesheets/common/drawer';
import { TimesheetTask } from '../../types';
import { AddTasksDrawerContent } from './content';

export const AddTasksDrawer: FC<{
  visible: boolean;
  projects: Project[];
  startDate: Moment;
  alreadyAddedTasks: TimesheetTask[];
  onAddTasks: (taskList: Task[]) => void;
  onClose: () => void;
  timesheetEntriesConfig: EnabledSourcesConfiguration;
}> = ({
  visible,
  projects,
  alreadyAddedTasks,
  onAddTasks,
  onClose,
  startDate,
  timesheetEntriesConfig,
}) => {
  return (
    <Drawer visible={visible} onClose={onClose} destroyOnClose>
      <AddTasksDrawerContent
        projects={projects}
        startDate={startDate}
        onAddTasks={onAddTasks}
        alreadyAddedTasks={alreadyAddedTasks}
        timesheetEntriesConfig={timesheetEntriesConfig}
      />
    </Drawer>
  );
};
